export default class OfferService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllOffers(args) {
    return this.axiosIns.get(this.serviceConfig.offers, { params: args });
  }

  deleteOffer(id) {
    return this.axiosIns.delete(`${this.serviceConfig.offers}/${id}`);
  }

  rejectOffer(id) {
    return this.axiosIns.patch(`${this.serviceConfig.offers}/${id}/reject`);
  }

  approveOffer(id) {
    return this.axiosIns.patch(`${this.serviceConfig.offers}/${id}/approve`);
  }

  editOffer(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.offers}/${id}`, args);
  }

  createOffer(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/offers`, args);
  }

  getOffer(id) {
    return this.axiosIns.get(`${this.serviceConfig.offers}/${id}`);
  }
}
